module.exports = __webpack_public_path__ + "static/supportNew@2x-b36e01a4175100516c5770328f93c7f9.png";


//////////////////
// WEBPACK FOOTER
// ./src/media/images/pages/contact-us/supportNew@2x.png
// module id = 2550
// module chunks = 221662759943617